<template>
    <div>
        <div id="data-list-thumb-view" class="data-list-container">
            <vs-table noDataText="کاتالوگی موجود نیست." pagination :max-items="10" search :data="catalogsList">

                <template slot="header">
                    <vs-button class="mb-4 float-right" type="flat" @click="addCatalog()">افزودن کاتالوگ</vs-button>
                </template>

                <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td class="img-container">
                            <img v-if="data[indextr].thumbnail" :src="srcFile(data[indextr].thumbnail)" class="product-img" />
                            <img v-else src="./../../../../assets/images/logo/logo.png" class="product-img">
                        </vs-td>

                        <vs-td>
                            <p class="product-name font-medium truncate">{{ data[indextr].title }}</p>
                        </vs-td>

                        <vs-td></vs-td>
                        <vs-td></vs-td>

                        <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-4 button-link" @click="editCatalog(data[indextr].id)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="mr-4 button-link" @click="deleteCatalog(data[indextr].id)" />
                            <feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-4 button-link" @click="downloadItem(data[indextr].url)" />
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>

            <AddCatalog :popupAddCatalog='popupAddCatalog' @updatePopupAddCatalog='updatePopupAddCatalog'/>

            <EditCatalog :popupEditCatalog='popupEditCatalog' :catalogId='editCatalogId' @updatePopupEditCatalog='updatePopupEditCatalog'/>

            <DeleteCatalog :popupDeleteCatalog='popupDeleteCatalog' :catalogId='deleteCatalogId' @updatePopupDeleteCatalog='updatePopupDeleteCatalog'/>
        </div>

    </div>
</template>

<script>
import AddCatalog from './Add'
import EditCatalog from './Edit'
import DeleteCatalog from './Delete'

export default {
    components: {
        AddCatalog,
        EditCatalog,
        DeleteCatalog,
    },

    data() {
		return{
        popupAddCatalog: false,
        popupEditCatalog: false,
        popupDeleteCatalog: false,

        editCatalogId: 0,
        deleteCatalogId: 0,
		}
	},

    
    computed: {
        catalogsList() {
            return this.$store.state.posts.catalogs
        }
    },
    
    created() {
        this.$vs.loading()
        this.$store.dispatch("getPosts","catalog").then(() => {
            this.$vs.loading.close();
        }).catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
    },

    methods: {
        srcFile(src) {
            return 'https://appapi.akambc.com/' + src
        },
        
        downloadItem(src) {
            window.open(src)
        },

        addCatalog(){
			      this.popupAddCatalog = true
		    },

        editCatalog(id){
            this.popupEditCatalog = true
            this.editCatalogId = id
        },
        
        deleteCatalog(id){
            this.popupDeleteCatalog = true
            this.deleteCatalogId = id
        },

        updatePopupAddCatalog(value){
            this.popupAddCatalog = value
        },

        updatePopupEditCatalog(value){
            this.popupEditCatalog = value
        },
        
        updatePopupDeleteCatalog(value){
            this.popupDeleteCatalog = value
        },
    }
}
</script>

<style lang="scss">
.button-link {
	  cursor: pointer;
}

#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>